import { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { parse } from 'querystringify'

// Actions
import { actions as authActions } from 'modules/auth/actions'
import { actions as subscriptionActions } from 'modules/signup/actions'

// Components
import { Spinner } from '@tracklib/kit'
import SignupForm from 'components/nologin/signup/signupform'
import SocialAuthForm from 'components/nologin/socialauthform'

// Hooks
import { useRequest } from 'modules/requests/hooks'

// Types
import { Country, State } from 'types'

// Utils
import { safeLocalStorage as localStorage } from 'utils'

type SignupProps = {
  refcode?: string
  refcodeValid?: boolean
  onDone?: () => void
  showSignupCode?: boolean
  // mapStateToProps
  email: string
  countryOptions: Array<Country>
  // mapDispatchToProps
  connectAndFetchSocial: () => Promise<Record<string, unknown>>
  registerAccount: (data: Record<string, unknown>) => Promise<Record<string, unknown>>
}

const Signup = ({
  email,
  connectAndFetchSocial,
  registerAccount,
  onDone,
  refcode,
  refcodeValid,
  countryOptions,
  showSignupCode,
}: SignupProps): JSX.Element => {
  const dispatch = useDispatch()
  const fetchUserCountryRequest = useRequest('FETCH_USER_COUNTRY')
  useEffect(() => {
    dispatch(subscriptionActions.fetchUserCountry())
  }, [dispatch])

  const initial_referrer = localStorage.getItem('initialReferrer') || ''
  const landing_url = localStorage.getItem('landingUrl') || ''
  const currentHref = window && window.location && window.location.href
  const signup_url = currentHref
  localStorage.setItem('signupUrl', currentHref)
  const ref = refcode !== 'default' ? refcode : null

  if (!fetchUserCountryRequest.isDone) {
    return <Spinner minHeight={500} delay={0} />
  }
  return (
    <div>
      <SocialAuthForm handleClick={() => connectAndFetchSocial()} signup />
      <SignupForm
        countryOptions={countryOptions}
        onSubmit={registerAccount}
        onDone={onDone}
        showSignupCode={!!showSignupCode}
        refcodeValid={!!refcodeValid}
        initialValues={{
          email,
          ref,
          initial_referrer,
          landing_url,
          signup_url,
        }}
      />
    </div>
  )
}

const mapStateToProps = (state: State) => {
  const { search } = state.router.location
  const query = parse(search)
  const { email } = query as { email: string }
  return {
    countryOptions: state.entities.countryOptions,
    email,
  }
}

const mapActions = {
  registerAccount: authActions.registerAndLogin,
  connectAndFetchSocial: authActions.connectAndFetchSocial,
}

export { Signup as Component }
export default connect(mapStateToProps, mapActions)(Signup)
